import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import NewTicketModal from "../../components/NewTicketModal";
import ScheduleModal from "../../components/ScheduleModal";
import ContactModal from "../../components/ContactModal";
import CardModal from "./CardModal";
import { ThemeContext } from "../../context/Theme/ThemeContext";
import whatsappBusinesse from "../../assets/icons/wppbusiness.svg";
import whatsapp from "../../assets/icons/whatsapp.svg";
import "../../css/pages/SalesFunnel/Card.css";
import { ModalPadrao }from "../../components/modalPadrao";
import { AuthContext } from "../../context/Auth/AuthContext";

const DefaultAvatarIcon = () => (
	<svg className="sf-card-avatar-default-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
		<circle cx="12" cy="8" r="3.25" />
		<path d="M5 20c0-3.5 3.13-6 7-6s7 2.5 7 6" />
	</svg>
);
const EditIcon = () => (
	<svg className="sf-card-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
);
const AssignmentIcon = () => (
	<svg className="sf-card-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M12 11h4"/><path d="M12 16h4"/><path d="M8 11h.01"/><path d="M8 16h.01"/></svg>
);

const ScheduleIcon = () => (
	<svg className="sf-card-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
);
const MessageIcon = () => (
	<svg className="sf-card-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
);
const DeleteIcon = () => (
	<svg className="sf-card-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>
);
const AttachIcon = () => (
	<svg className="sf-card-attach-badge-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
);

function hexBlend(hexBase, hexColor, ratio = 0.06) {
	const parse = (h) => {
		const m = String(h).match(/^#?([0-9a-f]{6})$/i);
		return m ? [parseInt(m[1].slice(0, 2), 16), parseInt(m[1].slice(2, 4), 16), parseInt(m[1].slice(4, 6), 16)] : null;
	};
	const b = parse(hexBase);
	const c = parse(hexColor);
	if (!b || !c) return hexBase;
	return `rgb(${Math.round(b[0] * (1 - ratio) + c[0] * ratio)}, ${Math.round(b[1] * (1 - ratio) + c[1] * ratio)}, ${Math.round(b[2] * (1 - ratio) + c[2] * ratio)})`;
}

const Card = ({ contact, removeCard, users, reloadBoard,openConversation }) => {
	const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
	const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
	const [contactModalOpen, setContactModalOpen] = useState(false);
	const [cardModalOpen, setCardModalOpen] = useState(false);
	const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
	const [profilePicError, setProfilePicError] = useState(false);
	const [coverError, setCoverError] = useState(false);
	const { darkMode } = useContext(ThemeContext);

	const { user } = useContext(AuthContext);
	const userId = user?.profile !== "admin" ? user?.id : null;
	const contactCover =
		contact?.funnelContact?.cover ?? contact?.FunnelContact?.cover;

	useEffect(() => {
		setProfilePicError(false);
	}, [contact?.id, contact?.profilePicUrl]);

	useEffect(() => {
		setCoverError(false);
	}, [contact?.id, contactCover]);

	const formatNumber = (number) => {
		if (!number) return "";
		const n = String(number);
		if (n.length === 13) return `(${n.slice(2, 4)}) ${n.slice(4, 9)}-${n.slice(9, 13)}`;
		if (n.length === 12) return `(${n.slice(2, 4)}) ${n.slice(4, 8)}-${n.slice(8, 12)}`;
		return n;
	};

	const handleNewTicketModalOpen = () => {
		if (!contact) return;
		setNewTicketModalOpen(true);
	};

	const openDeleteConfirm = () => setDeleteConfirmOpen(true);
	const closeDeleteConfirm = () => setDeleteConfirmOpen(false);

	const removeContact = async (contactId) => {
		const salesFunnelColumnId = contact.salesFunnelColumnId;
		const salesFunnelId = parseInt(window.location.hash.replace('#',''))
		if (!salesFunnelId) return;
		try {
			await api.post("/sales-funnel/unpin-contact", {
				contactId,
				salesFunnelColumnId,
				salesFunnelId,
				requestUserId: userId
			});
			removeCard(contactId);
			closeDeleteConfirm();
		} catch (error) {
			console.log(error);
		}
	};

	const handleContainerClick = (e) => {
		const cls = e.target.classList?.[0];
		if (cls && typeof cls === "string" && cls.length > 1 && !e.target.closest("button")) {
			setCardModalOpen(true);
		}
	};

	const borderColor = contact.columnCardColor || "#e5e7eb";
	const hasCardColor = !!contact.columnCardColor;
	const baseBg = darkMode ? "#1B1D1D" : "#ffffff";
	const innerBg = hasCardColor ? hexBlend(baseBg, borderColor, 0.07) : (darkMode ? "#1B1D1D" : "white");
	const funnelContact = contact.funnelContact ?? contact.FunnelContact;
	const attachmentsList = Array.isArray(funnelContact?.attachments) ? funnelContact.attachments : (typeof funnelContact?.attachments === "string" ? (() => { try { const a = JSON.parse(funnelContact.attachments); return Array.isArray(a) ? a : []; } catch (_) { return []; } })() : []);
	const attachmentCount = attachmentsList.length;

	return (
		<>
			<div
				className={`sf-card${darkMode ? " sf-card--dark" : ""}`}
				style={{
					backgroundColor: hasCardColor ? innerBg : baseBg,
					borderLeft: `4px solid ${borderColor}`,
				}}
			>
				<div className="sf-card-badges">
					{attachmentCount > 0 && (
						<span
							className="sf-card-attach-badge"
							title={`${attachmentCount} anexo(s)`}
							style={{
								backgroundColor: borderColor,
								color: hasCardColor ? "#fff" : "#334155",
							}}
						>
							<AttachIcon />
							<span className="sf-card-attach-badge-count">{attachmentCount}</span>
						</span>
					)}
					<span
						className="sf-card-ticket-badge"
						title={`Ticket #${contact.id}`}
						style={{
							backgroundColor: borderColor,
							color: hasCardColor ? "#fff" : "#334155",
						}}
					>
						#{contact.id}
					</span>
				</div>
				<ContactModal
					open={contactModalOpen}
					onClose={() => { reloadBoard(); setContactModalOpen(false); }}
					aria-labelledby="form-dialog-title"
					contactId={contact.id}
				/>
				<ScheduleModal
					open={scheduleModalOpen}
					onClose={() => { reloadBoard(); setScheduleModalOpen(false); }}
					aria-labelledby="form-dialog-title"
					scheduleId={null}
					contact={contact}
				/>
				<NewTicketModal
					initialContact={contact}
					modalOpen={newTicketModalOpen}
					onClose={() => { reloadBoard(); setNewTicketModalOpen(false); }}
				/>
				<CardModal
					modalOpen={cardModalOpen}
					srcCover={(contact.funnelContact ?? contact.FunnelContact)?.cover}
					darkMode={darkMode}
					onClose={() => { reloadBoard(); setCardModalOpen(false); }}
					selectedCard={contact.funnelContact ?? contact.FunnelContact}
					contact={contact}
					reloadBoard={reloadBoard}
				/>
				{deleteConfirmOpen && (
					<ModalPadrao
						type={"excluir"}
						titlePrincipal={"Excluir cartão?"}
						messagePrincipal={"O cartão será removido desta coluna. O contato não será apagado e poderá ser adicionado novamente ao funil."}
						open={deleteConfirmOpen}
						onClose={closeDeleteConfirm}
						onConfirm={() => removeContact(contact.id)}
					>
					</ModalPadrao>
				)}
				{(contact.funnelContact ?? contact.FunnelContact)?.cover && !coverError ? (
					<img
						className="sf-card-cover"
						src={(contact.funnelContact ?? contact.FunnelContact).cover}
						alt=""
						onError={() => setCoverError(true)}
					/>
				) : (
					<div style={{ height: 5 }} />
				)}
				<div
					className="sf-card-container"
					style={{ background: innerBg }}
					onClick={handleContainerClick}
					role="button"
					tabIndex={0}
					onKeyDown={(e) => e.key === "Enter" && setCardModalOpen(true)}
				>
					<div className="sf-card-contact-header">
						<div className={`sf-card-avatar-wrap${["whatsapp", "whatsappbusiness", "whatsapp_business_account"].includes(contact.channel) && !contact.isGroup ? " sf-card-avatar-wrap--with-badge" : ""}`}>
							<div className="sf-card-avatar">
								{contact.profilePicUrl && !profilePicError ? (
									<img
										src={contact.profilePicUrl}
										alt=""
										onError={() => setProfilePicError(true)}
									/>
								) : (
									<>
										<DefaultAvatarIcon />
										{contact.isGroup && (
											<span className="sf-card-avatar-initials sf-card-avatar-initials-overlay">G</span>
										)}
									</>
								)}
							</div>
							{["whatsapp", "whatsappbusiness", "whatsapp_business_account"].includes(contact.channel) && !contact.isGroup && (
								<span className="sf-card-channel-badge">
									{["whatsapp"].includes(contact.channel) ? (
										<img src={whatsapp} className="sf-card-channel-badge-icon" width="18" height="18" alt="WhatsApp" />
									) : (
										<img src={whatsappBusinesse} className="sf-card-channel-badge-icon sf-card-channel-badge-icon--business" width="18" height="18" alt="WhatsApp Business" />
									)}
								</span>
							)}
						</div>
						<div className="sf-card-contact-info">
							<span className="sf-card-contact-title">{contact.name || "Sem nome"}</span>
							{(["whatsapp", "whatsappbusiness"].includes(contact.channel) && !contact.isGroup && contact.number) ? (
								<span className="sf-card-contact-number">{formatNumber(contact.number)}</span>
							) : contact.channel === "email" && contact.email ? (
								<span className="sf-card-contact-email" title={contact.email}>{contact.email}</span>
							) : null}
						</div>
					</div>
					<div className="sf-card-info-box">
						<div className="sf-card-info-row">
							<span className="sf-card-description">{contact.funnelContact?.description}</span>
						</div>
						{contact.funnelContact?.userId && (
							<div className="sf-card-info-row">
								<span className="sf-card-description">
									<strong style={{ marginRight: 3 }}>Responsável:</strong>{" "}
									{users?.find((u) => u.id === contact.funnelContact?.userId)?.name}
								</span>
							</div>
						)}
						{contact.tags?.length > 0 && (
							<div className="sf-card-tags-box">
								{contact.tags.map((tag) => (
									<span
										key={tag.id}
										className="sf-card-tag"
										style={{ backgroundColor: tag.color }}
										title={tag.name}
									>
										{tag.name}
									</span>
								))}
							</div>
						)}
						{contact.funnelContact?.valor && (
							<div className="sf-card-info-row">
								<span className="sf-card-description">
									<strong style={{ marginRight: 3 }}>R$:</strong>{" "}
									{Number(String(contact.funnelContact.valor).replace(",", ".")).toFixed(2)}
								</span>
							</div>
						)}
					</div>
					<div className="sf-card-footer">
						<span
							className="sf-card-expires"
							title="Data limite"
						>
							{contact.funnelContact?.expiresIn &&
								new Date(contact.funnelContact.expiresIn).toLocaleDateString("pt-BR")}
						</span>
						<div className="sf-card-actions-box">
							<button type="button" className="sf-card-action-btn" title="Editar cartão" onClick={() => setCardModalOpen(true)}><EditIcon /></button>
							<button type="button" className="sf-card-action-btn" title="Dados do contato" onClick={() => setContactModalOpen(true)}><AssignmentIcon /></button>
							<button type="button" className="sf-card-action-btn" title="Agendar mensagem" onClick={() => setScheduleModalOpen(true)}><ScheduleIcon /></button>
									<div style={{ position: "relative" }}>
								{contact.tickets[0] && (
									<span style={{
										position: "absolute", top: 5,
										right: 5,
										width: 10,
										height: 10,
										background: "#07e007",
										borderRadius: "50%"
									}}></span>
								)}
								{
									contact.tickets?.[0] ? (
										<button type="button" className="sf-card-action-btn" title="Conversa" onClick={() => openConversation(contact.tickets?.[0]?.id)}><MessageIcon /></button>
									) : (<button type="button" className="sf-card-action-btn" title="Abrir ticket" onClick={handleNewTicketModalOpen}><MessageIcon /></button>)
								}

							</div>
							<button type="button" className="sf-card-action-btn" title="Excluir cartão" onClick={(e) => { e.stopPropagation(); openDeleteConfirm(); }}><DeleteIcon /></button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Card;
